<h4 style="margin-top: -12px;">
  Action Recommendation Standard Rules   <button mat-raised-button color="warn" (click)="openAddRecommendationDetails(0)">{{'+ Rule' | translate | async}}</button>
</h4>
<button mat-icon-button class="close-button" [mat-dialog-close]="true" style="margin-top:-10px">  <mat-icon class="close-icon" color="warn">close</mat-icon></button>
<div class="margin-bottom-24">
  <div style="margin-left: 32%; position:absolute; vertical-align: middle; align-content:center;" *ngIf="loading">
    <mat-spinner> </mat-spinner>
  </div>
  <mat-form-field>
    <mat-select placeholder="{{'Customer' | translate | async}}" [(ngModel)]="selectedCustomer" (selectionChange)="loadJobSites()" ngDefaultControl required>
      <mat-option [value]="0">
       All Customers
      </mat-option>
      <mat-option [value]="customer.Id" *ngFor="let customer of customers">
        {{customer.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-select placeholder="{{'Job Site' | translate | async}}" [(ngModel)]="selectedJobsite" (selectionChange)="loadModels()" ngDefaultControl required>
      <mat-option [value]="0">
        All Jobsites
       </mat-option>
      <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsites">
        {{jobsite.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-select placeholder="{{'Model' | translate | async}}" [(ngModel)]="selectedModel" ngDefaultControl required>
      <mat-option [value]="0">
        All Models
       </mat-option>
      <mat-option [value]="model.Id" *ngFor="let model of models">
        {{model.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div style="margin-left: 566px; margin-top: -54px;">
    <a class="button" (click)="ResetFields();"><span class="button__text">Reset</span></a>
    <a class="button button--primary" style="margin-left: 20px;" (click)="getRules();"><i class="material-icons button__icon">search</i><span class="button__text">Search</span></a>
  </div>
</div>
<div>
  <mat-table [dataSource]="dataSource" matSort class="table-material table-material--striped table-material--hover table-material--full-width mat-elevation-z8">
    <!-- <ng-container matColumnDef="RuleId">
      <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
        {{'Auto #'| translate | async}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="tableCell">
        <div class="SerialAndUnitText" style="width:25px"> {{element.RuleId}}</div>
      </mat-cell>
    </ng-container> -->
    <ng-container matColumnDef="Model">
      <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
        {{'Model'| translate | async}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="tableCell">
        <div class="SerialAndUnitText"> {{element.Model}} </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Customer">
      <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
        {{'Customer'| translate | async}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="tableCell">
        <div class="SerialAndUnitText"> {{element.Customer}} </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Jobsite">
      <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
        {{'Job Site'| translate | async}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="tableCell">
        <div class="SerialAndUnitText"> {{element.JobSite}} </div>
      </mat-cell>
    </ng-container>
    
    <ng-container matColumnDef="RuleName">
      <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
        {{'Rule (Name)'| translate | async}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="tableCell">
        <div class="SerialAndUnitText">{{element.RuleName}} </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="RuleDesc">
      <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
        {{'Rule Desc'| translate | async}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.RuleDesc}}">
        <div class="SerialAndUnitText">{{element.RuleDesc}} </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Components">
      <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
        {{'Components Affected'| translate | async}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="tableCell" matTooltip="{{element.Components}}">
        <div class="SerialAndUnitText">{{element.Components}} </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="CreatedUser">
      <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
        {{'Created By'| translate | async}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="tableCell">
        <div class="SerialAndUnitText" style="width: 75px;"> {{element.CreatedUser}} </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Date">
      <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
        {{'Date'| translate | async}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="tableCell">
        <div class="SerialAndUnitText" style="width: 75px;"> {{element.Date | date: 'dd MMM yyyy'}} </div>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openAddRecommendationDetails(row.RuleId)" class="row-hover" title="Click to add/edit rule component(s)."></mat-row>
  </mat-table>
</div>
